import React, { useMemo } from 'react'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import Table from 'components/visualization/Table'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { WidgetId } from 'features/types'
import { convertToTableData, convertToColDefs, calcConstraints } from './tableUtils'
import { TopicComparisonWidgetType } from '../../types'

interface TopicComparisonWidgetProps {
  widgetId: WidgetId
  onRowClick?: (row: any) => void
}

const TopicComparisonWidget = ({ widgetId, onRowClick }: TopicComparisonWidgetProps) => {
  const widgetSetting = useDashboardWidgetSetting<TopicComparisonWidgetType>(widgetId)
  const { topicComparisonMeasures, showSummary } = widgetSetting

  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const { rowData, statistics } = useMemo(
    () => convertToTableData(widgetData.data, widgetSetting),
    [widgetData, widgetSetting]
  )

  const colDefs = convertToColDefs(topicComparisonMeasures!)
  const constraints = calcConstraints(rowData, colDefs)

  return (
    <Table
      rowData={rowData}
      colDefs={colDefs}
      context={{ statistics, constraints }}
      isDisplayFoot={showSummary!}
      onRowClick={onRowClick}
    />
  )
}

export default TopicComparisonWidget
